import type { RestoreJob } from '@repo/api-gw-sdk';

import {
  findPropertyInObject,
  type PropertyField,
} from '../queryBuilder/propertiesUtils';
import { Tags } from '../tags';

export const labelsField: PropertyField<RestoreJob> = {
  id: 'labels',
  group: 'Configuration',
  getTitle: () => {
    return 'Labels';
  },
  Component: ({ entity }) => {
    const labels = findPropertyInObject<Record<string, string>>(
      entity.configuration,
      'labels'
    );
    return labels && !!Object.entries(labels).length && <Tags tags={labels} />;
  },
};
